import {
  React,
  Component,
  withCookies,
  axios,
  routes
} from 'imports/CommonImports';


import {
  TextField,
  Paper,
  CircularProgress
} from 'material-ui';

import {
  CircleIcon,
  OneIcon
} from 'imports/IconsImports';

const styles = {
  questionText: {
    margin: '0.5em 0',
    fontWeight: 'bold'
  },
  question: {
    textAlign: 'left',
    paddingLeft: '1em',
    display: 'flex'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 12
  },
  subTitle: {
    marginTop: '0',
    paddingLeft: '2em',
    paddingRight: '2em',
  },
  state:{
    flex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '6em',
  },
  listItemContainer: {
    margin: '1.5em',
    backgroundColor: '#FBFBFB',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '1em 0',
    paddingBottom: '2em'
  }
}

class InnovationDef extends Component {
  constructor(props){
    super(props);
    this.state = {
      innovation_def: "",
      errorText:"",
      error: false,
      loading: true,
      definitionCompleted: false
    }
  }

  componentDidMount(){
    this.getInnovationDef();
  }

  render() {
    return (
      <Paper zDepth={1} style={styles.listItemContainer}>
        <div style={styles.titleContainer}>
          <div style={styles.question}>
            <h3 style={styles.questionText}><OneIcon /> Definición de Innovación</h3>
            {this.state.definitionCompleted ?
              <div style={styles.state}>
                <CircleIcon style={{color:'#11AB99'}}/><div>Completado</div>
              </div> :
              <div style={styles.state}>
                <CircleIcon style={{color: '#FF952B'}}/><div>Pendiente</div>
              </div>
            }
          </div>
          <p style={styles.subTitle}>El propósito de la definición de innovación es declarar en breves párrafos que se entiende por innovación en la empresa de manera que todos tengan un mismo criterio al postular los proyectos.</p>
        </div>
        {this.state.loading ?
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
        :
          <div style={{display:'flex'}}>
            <TextField
              name="innovation_definition"
              multiLine={true}
              value={this.state.innovation_def}
              fullWidth={true}
              rows={3}
              rowsMax={15}
              onChange={(event) => this.handleChange("innovation_def", event)}
              hintText="Escribe la definición de tu empresa."
              floatingLabelText="Definición de Innovación"
              floatingLabelFixed={true}
              errorText={this.state.errorText}
              disabled={this.props.done || false}
              style={{marginLeft:'2em', marginRight:'2em', marginBottom:'2em'}}
            />
          </div>
        }
      </Paper>
    );
  }

  handleChange = (type, event) => {
    var value = event.target.value;
    var newState = this.state;
    newState[type] = value;
    this.props.update(value);
    this.setState(newState);
  }

  getInnovationDef = () => {
    let token = this.props.cookies.get('token');
    let user = this.props.cookies.get('user');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.company(user.company_id))
      .then((response) => {
        var definitionCompleted = true;
        if(response.data.innovation_def === ""){
          definitionCompleted = false
        }
        this.props.update(response.data.innovation_def);
        this.setState({innovation_def: response.data.innovation_def, definitionCompleted: definitionCompleted, loading: false})
      })
      .catch((error) => {
        this.setState({error: true})
        console.log(error);
      });
  }
}

export default withCookies(InnovationDef);



// WEBPACK FOOTER //
// ./src/components/conventions/InnovationDef.js